import { Box, Button, Container, Typography, Alert } from "@mui/material";
import {
  IconChevronRight,
  IconCircleCheck,
  IconDotsCircleHorizontal,
} from "@tabler/icons-react";
import { map } from "lodash";
import moment, { Moment } from "moment";
import { useEffect, useState } from "react";
import { useUsuario } from "../../../providers/usuarioProvider";
import { limit, onSnapshot, orderBy, query } from "firebase/firestore";
import DeclaracaoDb from "../../../db/declaracaoDb";
import ImpostoDb from "../../../db/impostoDb";
import { Link } from "react-router-dom";
import { felixTokens } from "../../../theme";

export default function Declaracao() {
  const { visualizado } = useUsuario();
  const [dataInicio, setDataInicio] = useState<Moment>();

  useEffect(() => {
    if (!!visualizado)
      return onSnapshot(
        query(
          new ImpostoDb().collection({ usuarioId: visualizado, impostoId: "" }),
          orderBy("dataBase", "asc"),
          limit(1),
        ),
        (query) => {
          if (!query.empty)
            setDataInicio(query.docs[0].data().dataBase.clone());
        },
      );
  }, [visualizado]);

  return (
    <Container
      maxWidth="lg"
      sx={(theme) => ({
        padding: {
          md: theme.spacing(4, 8),
          xs: theme.spacing(2, 2),
        },
      })}
    >
      <Box display="flex" flexDirection="column">
        <Typography variant="eyebrow" color="text.secondary">
          Declaração
        </Typography>
        <Typography variant="h1" color="text.primary" pt={0.5}>
          Aqui estão os Relatórios para sua última Declaração
        </Typography>
        <Box display="flex" flexDirection="row" paddingY={4}>
          <CardDeclaracao
            idDeclaracao={moment().subtract(1, "year").year().toString()}
          />
        </Box>
        <Typography variant="h4" color="text.secondary">
          e os Relatórios para a Declaração de anos anteriores
        </Typography>
        <Box display="flex" flexDirection="row" paddingY={2}>
          {(function () {
            let anoDeclaracao = moment();
            let anos: number[] = [];
            while (anoDeclaracao.isSameOrAfter(dataInicio, "year")) {
              anoDeclaracao.subtract(1, "year");
              anos.push(anoDeclaracao.year());
            }
            anos.pop();
            return map(anos, (ano) => (
              <CardDeclaracao
                key={ano.toString()}
                idDeclaracao={ano.toString()}
              />
            ));
          })()}
        </Box>
      </Box>
    </Container>
  );
}

function CardDeclaracao({
  idDeclaracao: declaracaoId,
}: {
  idDeclaracao: string;
}): JSX.Element {
  const { visualizado } = useUsuario();
  const [existeDeclaracao, setExisteDeclaracao] = useState<boolean>();
  const [possivelFechar, setPossivelFechar] = useState<boolean>();

  useEffect(() => {
    if (!!visualizado)
      return onSnapshot(
        new DeclaracaoDb().doc({ usuarioId: visualizado, declaracaoId }),
        (doc) => {
          setExisteDeclaracao(doc.exists());
        },
      );
  }, [visualizado]);

  useEffect(() => {
    if (!!visualizado)
      return onSnapshot(
        new ImpostoDb().doc({
          usuarioId: visualizado,
          impostoId: `${declaracaoId}-12`,
        }),
        (doc) => {
          setPossivelFechar(doc.exists());
        },
      );
  }, [visualizado]);

  return (
    <Box paddingRight={2}>
      {!existeDeclaracao && (
        <Alert severity="info" sx={{ mb: 2 }}>
          O relatório anual ainda não está disponível.
          <br />
          Atualize sua <Link to="/timeline">Timeline</Link> para gerar o
          relatório da declaração deste ano.
        </Alert>
      )}
      {/* Sempre `outlined`: uma fileira de sete pílulas verdes sólidas dominava
          a tela, e verde contido não é uma das variantes de botão do sistema.
          O sinal de "relatório pronto" fica no ÍCONE, em `success` — a
          informação se mantém, o peso cromático não. */}
      <Button
        variant="outlined"
        color="inherit"
        startIcon={
          existeDeclaracao ? (
            <IconCircleCheck color="var(--felix-ok)" />
          ) : (
            <IconDotsCircleHorizontal />
          )
        }
        endIcon={<IconChevronRight size={32} />}
        component={Link}
        to={`/declaracao/${declaracaoId}`}
        disabled={!possivelFechar}
        // O rótulo do botão é o ano-calendário: número entra em mono tabular.
        sx={(theme) => ({
          fontFamily: felixTokens.fontMono,
          fontVariantNumeric: "tabular-nums",
          letterSpacing: "0.04em",
          "--felix-ok": theme.palette.success.main,
          ...(existeDeclaracao && { borderColor: theme.palette.divider }),
        })}
      >
        {declaracaoId}
      </Button>
    </Box>
  );
}
